import api from './api'

export const getLiftsByResort = async resortId => {
  try {
    const response = await api.get(`/ski-lifts/resort/${resortId}`)
    return response.data
  } catch (err) {
    console.error('Error fetching ski lifts:', err)
    throw err
  }
}

// Optional: If you build an import UI later
export const importLifts = async (geoJsonData, resortId) => {
  try {
    const response = await api.post('/ski-lifts/import', { 
        features: geoJsonData.features, 
        resort_id: resortId 
    })
    return response.data
  } catch (err) {
    console.error('Error importing lifts:', err)
    throw err
  }
}